import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobUploadForm/";

const getUploadForm = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUploadForm?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const startUploadForm = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'StartUploadForm', model, constants.REQUIRE_INTERCEPTORS);

const saveUploadForm = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveUploadForm', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true });

const renameFormAttachment = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'RenameFormAttachment', model, constants.REQUIRE_INTERCEPTORS);

const deleteFormAttachment = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteAttachment?jobFormAttachmentId=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getUploadForm,
    startUploadForm,
    saveUploadForm,
    renameFormAttachment,
    deleteFormAttachment,
}